import { render } from "./VueFinalModal.vue?vue&type=template&id=516ff708&scoped=true"
import script from "./VueFinalModal.vue?vue&type=script&lang=js"
export * from "./VueFinalModal.vue?vue&type=script&lang=js"

import "./VueFinalModal.vue?vue&type=style&index=0&id=516ff708&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516ff708"]])

export default __exports__